import { createSvgIcon } from '@mui/material';

export const Warning = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none">
    <path
      d="M12 7.97516V12.4186M12 16.862H12.011M10.4822 2.3006L1.46671 18.0821C0.966654 18.9574 0.716625 19.3951 0.753579 19.7543C0.785811 20.0676 0.947786 20.3524 1.19919 20.5376C1.48742 20.75 1.98645 20.75 2.9845 20.75H21.0155C22.0135 20.75 22.5126 20.75 22.8008 20.5376C23.0522 20.3524 23.2142 20.0676 23.2464 19.7543C23.2834 19.3951 23.0333 18.9574 22.5333 18.0821L13.5178 2.3006C13.0195 1.42839 12.7704 0.992292 12.4454 0.845822C12.1618 0.718059 11.8382 0.718059 11.5546 0.845822C11.2296 0.992292 10.9805 1.42839 10.4822 2.3006Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  'Warning',
);
